export const moveItemBetweenArrays = <T>(sourceItems: T[], destinationItems: T[], fromIndex: number, toIndex: number): [T[], T[]] => {
	const movedItem = sourceItems[fromIndex];

	const source = [...sourceItems];
	source.splice(fromIndex, 1);

	const destination = [...destinationItems];
	destination.splice(toIndex, 0, movedItem);

	return [source, destination];
};

export const makeUnique = (list: any[]): any[] => {
	return list.reduce((result, current) => {
		return result.includes(current) ? result : [...result, current];
	}, []);
};
